import React, { useEffect } from 'react';
import { Table, Button, Menu, MenuItem, Icon } from 'semantic-ui-react';
import classNames from 'classnames';
import api from '../../api';
import PromotionModal from './PromotionModal';
import Config from '../../constants/Config';
import styles from './Promotion.module.scss';
import moment from 'moment';

const Promotion = React.memo(() => {
  const [edit, setEdit] = React.useState({});
  const [isCheckOpen, setIsCheckOpen] = React.useState(false);
  const [listObj, setListObj] = React.useState({
    list: [],
    total: 0,
  });
  const [currentSkip, setCurrrentSkip] = React.useState(1);
  const handleCheck = (data) => {
    setEdit({
      promotionCode: data.promotionCode,
      id: data.id,
      name: data.name,
      phone: data.phone,
      email: data.email,
      promotionCommission: data.promotionCommission * 100,
    });
    setIsCheckOpen(true);
  };
  const getInfo = React.useCallback(() => {
    api
      .getPromotion({
        limit: Config.AONNOUCEMENT_LIMIT,
        skip: currentSkip - 1,
      })
      .then((res) => {
        setListObj({ list: res.item, total: res.total });
      });
  }, [currentSkip]);

  const onClose = () => {
    setIsCheckOpen(false);
    setEdit({});
  };
  const again = React.useCallback(() => {
    setCurrrentSkip(1);
    getInfo();
  }, [getInfo]);
  useEffect(() => {
    getInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSkip]);
  return (
    <div className={styles.app}>
      <Button
        positive
        content="新增推广员"
        onClick={() => {
          setIsCheckOpen(true);
        }}
      />

      <Table celled unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>姓名</Table.HeaderCell>
            <Table.HeaderCell width={1}>推广码</Table.HeaderCell>
            <Table.HeaderCell width={1}>用户名</Table.HeaderCell>
            <Table.HeaderCell width={2}>手机号</Table.HeaderCell>
            <Table.HeaderCell width={2}>邮箱</Table.HeaderCell>
            <Table.HeaderCell width={1}>佣金比例</Table.HeaderCell>
            <Table.HeaderCell width={2}>添加时间</Table.HeaderCell>
            <Table.HeaderCell width={1}>操作</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {listObj.list.map((item) => (
            <Table.Row key={item.id}>
              <Table.Cell>{item.name}</Table.Cell>
              <Table.Cell>{item.promotionCode}</Table.Cell>
              <Table.Cell>{item.username}</Table.Cell>
              <Table.Cell>{item.phone}</Table.Cell>
              <Table.Cell>{item.email}</Table.Cell>
              <Table.Cell>{item.promotionCommission * 100}%</Table.Cell>
              <Table.Cell>
                {item.createdAt && moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')}
              </Table.Cell>
              <Table.Cell>
                <button
                  type="button"
                  className={styles.action}
                  onClick={() => {
                    handleCheck(item);
                  }}
                >
                  编辑
                </button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
        {!!listObj.list.length && (
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="8">
                <Menu floated="right" pagination>
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre <= 1) {
                          return 1;
                        }
                        return pre - 1;
                      });
                    }}
                  >
                    <Icon name="chevron left" />
                  </MenuItem>
                  {Array.from({ length: listObj.total }, (_, index) => (
                    <MenuItem
                      as="a"
                      key={index}
                      className={classNames(index + 1 === currentSkip && styles.menuItemActive)}
                      onClick={() => {
                        setCurrrentSkip(index + 1);
                      }}
                    >
                      {index + 1}
                    </MenuItem>
                  ))}
                  <MenuItem
                    as="a"
                    icon
                    onClick={() => {
                      setCurrrentSkip((pre) => {
                        if (pre + 1 >= listObj.total) {
                          return listObj.total;
                        }
                        return pre + 1;
                      });
                    }}
                  >
                    <Icon name="chevron right" />
                  </MenuItem>
                </Menu>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        )}
      </Table>
      {isCheckOpen && <PromotionModal edit={edit} onInfo={again} onClose={onClose} />}
    </div>
  );
});

export default Promotion;
